import React, { useState } from "react";

const ForgotPasswordAgent = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    const res = await fetch(
      "https://keurgui-backend-kjour.ondigitalocean.app/api/forgot-password-agent",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      }
    );

    const data = await res.json();
    setMessage(data.message);
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h4>Mot de passe oublié</h4>

        <form onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder="Votre courriel"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <button type="submit">Envoyer le lien</button>
        </form>

        {message && <p>{message}</p>}
      </div>
    </div>
  );
};

export default ForgotPasswordAgent;